import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { exportTListResidentExcel } from '../../Functions/exportListResidentExcel';
import '../../Css/FactureEtablie.css';

const ClientTable = () => {
    const [clients, setClients] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [filters, setFilters] = useState({
        passport: "",
        clientName: "",
    });
    const [currentPage, setCurrentPage] = useState(0);
    const [rowspage, setRowsPage ] = useState(12); 
    const [isModalOpen, setIsModalOpen] = useState(false);  // For modal visibility
    const [editedClient, setEditedClient] = useState(null);  // To track which client is being edited

    const token = localStorage.getItem('token'); 
    const apiUrl = process.env.REACT_APP_API_URL;

    const handleFilterChange = useCallback(
        (e) => {
            const { name, value } = e.target;
            setFilters((prev) => ({ ...prev, [name]: value }));
        },
        [setFilters]
    );

        // Handle change Montant_achat field
        const handleRowsPageChange = (e) => {
            let value = e.target.value;
             setRowsPage(value);
        };

    const fetchData = async () => {
        setLoading(true);
        setError(null); 
        try {
            let params = new URLSearchParams();
            Object.keys(filters).forEach(key => {
                if (filters[key]) {
                    params.append(key, filters[key]);
                }
            });
            const clientsRes = await fetch(`${apiUrl}/api/facture_client?${params.toString()}`, {
                headers: { 'Authorization': `Bearer ${token}` },
            });
            const clientsData = await clientsRes.json();
            setClients(clientsData);
            if(clientsData.length > 0){
                setCurrentPage(1);
            }
            
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const handleSearchClick = () => {
        fetchData();
    };



    const paginateData = useMemo(() => {
        const sortedClients = [...clients].sort((a, b) => {
            return new Date(b.createdAt) - new Date(a.createdAt);
        });
    
        const startIndex = (currentPage - 1) * rowspage;
        const endIndex = startIndex + parseInt(rowspage); // Assurez-vous que rowspage est un nombre
        return sortedClients.slice(startIndex, endIndex);
    }, [clients, currentPage, rowspage]); // Ajoutez rowspage comme dépendance

    const totalPages = Math.ceil(clients.length / rowspage);
    const goToPage = (page) => setCurrentPage(page);

    const isPrevDisabled = currentPage === 1 || clients.length === 0;
    const isNextDisabled = currentPage === totalPages || clients.length === 0;

    if (loading) {
        return (
            <div className="loader">
                <div className="spinner"></div>
            </div>
        );
    }

    if (error) {
        return <div className='Facturetablie__ErrorAPI'>Error: {error}</div>;
    }



    const exportTableInExcel = () => exportTListResidentExcel(clients);

    const openEditModal = (client) => {
        setEditedClient(client);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setEditedClient(null);
    };


    const handleDelete = async (id) => {
        if (window.confirm('Are you sure you want to delete this client?')) {
          try {
            const response = await fetch(`${apiUrl}/api/facture_client/${id}`, {
              method: 'DELETE',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
              },
            });
    
            if (!response.ok) {
              return ;
            }
            fetchData();
          } catch (error) {
            alert(error.message);
          }
        }
      };




      const handleUpdate = async () => {
        if (!editedClient.passport || !editedClient.clientName) {
            alert('Please fill out both fields.');
            return;
        }
        try {
            const response = await fetch(`${apiUrl}/api/facture_client/${editedClient.id}`, {
                method: 'PUT', 
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    passport: editedClient.passport,
                    clientName: editedClient.clientName,
                }),
            });
    
            if (!response.ok) {
                throw new Error('Failed to update the client.');
            }

            closeModal();
            alert('Client updated successfully.');
            fetchData();
        } catch (error) {
            console.error('Update failed:', error);
            alert('There was an error updating the client.');
        }
    };
    

    return (
        <div className="Facturetablie">
            <h2 className="Facturetablie__title">Base de donneés des clients</h2>

            <div className="Facturetablie__filterSection1">
                <div className='Facturetablie__filterSection'>
                    {['Passport', 'ClientName'].map((filter, index) => (
                        <div className="Facturetablie__filterGroup1" key={index}>
                            <label htmlFor={filter}>{filter}</label>
                            <input
                                className="Facturetablie__filterInput"
                                type='text'
                                name={filter}
                                id={filter}
                                value={filters[filter]}
                                onChange={handleFilterChange}
                                placeholder='filter'
                            />
                        </div>
                    ))}
                </div>

                <button className="Facturetablie__searchButton" onClick={handleSearchClick}>Search</button>
            </div>


            <div className="Facturetablie__exportation">
                <button className="Facturetablie__exportButton" onClick={exportTableInExcel}>Exporter en Excel</button>
            </div>

    {/* Pagination */}
    <div className='Facturetablie__paginationarea'>
        <div className="Facturetablie__pagination">
           <button disabled={isPrevDisabled} onClick={() => goToPage(currentPage - 1)}>&lt; Prev</button>
           <span>Page {currentPage} of {totalPages}</span>
           <button disabled={isNextDisabled} onClick={() => goToPage(currentPage + 1)}>Next &gt;</button>

           <input
            type="text"
            className="Facturetablie__rowspage"
            value={rowspage}
            onChange={handleRowsPageChange}
        />
        </div>
    </div>

            <table className="Facturetablie__table">
                <thead>
                    <tr className="Facturetablie__headerRow">
                        {[
                            { name: "passport", label: "Passport" },
                            { name: "clientName", label: "Nom du client" },
                        ].map(({ name, label }) => (
                            <th key={name}>{label}</th>
                        ))}
                        <th>Actions</th>
                    </tr>
                </thead>

                <tbody>
                    {paginateData.length > 0 ? (
                        paginateData.map((item) =>
                            <tr key={`${item.id}`}>
                                <td>{item.passport}</td>
                                <td>{item.clientName}</td>
                                <td className='Facturetablie__buttonarea1'>
                                    <button className="facturesContainer__editFacture" onClick={() => openEditModal(item)}>Edit</button>
                                    <button className="facturesContainer__exportPDF" onClick={() => handleDelete(item.id)}>Delete</button>
                                </td>
                            </tr>
                        )
                    ) : (
                        <tr><td colSpan="10" className='not-found'>No results found.</td></tr>
                    )}
                </tbody>
            </table>


            {/* Modal */}
            {isModalOpen && (
                <div className="Facturetablie__modal">
                    <div className="Facturetablie__modal-content">
                        <h3>Edit Client</h3>
                        <label>Passport</label>
                        <input
                            type="text"
                            value={editedClient.passport}
                            onChange={(e) => setEditedClient({ ...editedClient, passport: e.target.value })}
                        />
                        <label>Client Name</label>
                        <input
                            type="text"
                            value={editedClient.clientName}
                            onChange={(e) => setEditedClient({ ...editedClient, clientName: e.target.value })}
                        />
                        <div className='Facturetablie__button'>
                            <button onClick={handleUpdate}>Update</button>
                            <button onClick={closeModal}>Cancel</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ClientTable;
